import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { fromJS, List, Map } from 'immutable';
import { Document } from '../../../document-data/document.model';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { IFormMasterBuilder } from '../../../form-master/form-master.interface';
import { CompanySettings } from '../../../settings-data/sub-models/company-settings/company-settings.model';
import { PaymentReminders } from '../../../settings-data/sub-models/company-settings/payment-reminders.model';
import { DocumentPresetSettings } from '../../../settings-data/sub-models/document-preset-settings/document-preset-settings.model';
import { SettingsContent } from '../../../settings-data/sub-models/settings-content.model';
import { DateTimeService } from 'i2g-ng-utils';

@Injectable()
export class DocumentPaymentOptionsBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    REMINDERS_ENABLED: 'remindersEnabled',
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _dateTimeService: DateTimeService
  ) {}

  buildForm(
    remindersSettings: PaymentReminders,
    documentSettings: DocumentPresetSettings,
    featureToggles: Toggles
  ): FormGroup {
    const featureName = Toggles.KEYS.PAYMENT_REMINDERS;

    return this._formBuilder.group({
      [this.FORM_KEYS.REMINDERS_ENABLED]: [
        {
          value:
            remindersSettings.enabled &&
            !documentSettings.remindersDisabled &&
            featureToggles.isAllAccess(featureName),
          disabled:
            featureToggles.isReadOnlyAccess(featureName) ||
            featureToggles.isForbidden(featureName),
        },
      ],
    });
  }

  buildDocumentSettingsPropsFromReminders(
    remindersEnabled: boolean
  ): Map<string, any> {
    return fromJS({
      [Document.CONTENT_KEYS.SETTINGS]: {
        [DocumentPresetSettings.KEYS.REMINDERS_DISABLED]: !remindersEnabled,
      },
    });
  }

  buildDocumentSettingsPropsForI2gMoney(
    i2gMoneyEnabled: boolean
  ): Map<string, any> {
    return fromJS({
      [Document.CONTENT_KEYS.SETTINGS]: {
        [DocumentPresetSettings.KEYS.BANK_TRANSFER_DISABLED]: !i2gMoneyEnabled,
      },
    });
  }

  buildDocumentSettingsPropsForBankTransfer(
    bankTransferEnabled: boolean
  ): Map<string, any> {
    return fromJS({
      [Document.CONTENT_KEYS.SETTINGS]: {
        [DocumentPresetSettings.KEYS
          .BANK_TRANSFER_DISABLED]: !bankTransferEnabled,
      },
    });
  }

  buildDocumentSettingsPropsForCardPayments(
    cardPaymentsEnabled: boolean
  ): Map<string, any> {
    return fromJS({
      [Document.CONTENT_KEYS.SETTINGS]: {
        [DocumentPresetSettings.KEYS
          .CARD_PAYMENTS_DISABLED]: !cardPaymentsEnabled,
      },
    });
  }

  buildDocumentSettingsPropsForPaypal(
    paypalEcEnabled: boolean
  ): Map<string, any> {
    return fromJS({
      [Document.CONTENT_KEYS.SETTINGS]: {
        [DocumentPresetSettings.KEYS.PAYPAL_EC_DISABLED]: !paypalEcEnabled,
      },
    });
  }

  buildSettingsPropsFromReminders(
    enabled: boolean,
    remindIn: List<number>
  ): Map<string, any> {
    return fromJS({
      [SettingsContent.KEYS.COMPANY_SETTINGS]: {
        [CompanySettings.KEYS.PAYMENT_REMINDERS]: {
          [PaymentReminders.KEYS.ENABLED]: enabled,
          [PaymentReminders.KEYS
            .OLSON_TIMEZONE]: this._dateTimeService.getTimezone(),
          [PaymentReminders.KEYS.REMIND_IN]: remindIn,
        },
      },
    });
  }
}
